import ConvinceStub from '@/lib/ConvinceStub'
import _ from 'lodash'
const convince = window.convince || ConvinceStub

export function getScoringTranslationContext (scoring, setId, bandId) {
  return `scoring.${setId}.bands.${bandId}`
}

export default {
  computed: {
    debugMode: function () {
      if (document.location.search.match(/debug=1/)) {
        return true
      }
      return this.$store.state.config.debug
    },
    convince: function () {
      return convince
    },
    entries: function () {
      return this.$store.state.entries
    },
    validateConfig () {
      const config = this.$store.state.config
      const result = { ok: true, errors: [] }
      if (_.isEmpty(config.theme)) {
        result.ok = false
        result.errors.push('Missing theme')
      }
      return result
    },
    questions () {
      const config = this.$store.state.config
      const qs = []
      const exclude = ['barrier', 'user-info']
      for (let i = 0; i < config.pages.length; i++) {
        const page = config.pages[i]
        if (page.type === 'SurveyPage' && exclude.indexOf(page.id) === -1) {
          qs.push(page)
        }
      }
      return qs
    }
  },
  methods: {
    getScoreSetById (id) {
      const filtered = this.$store.state.config.scoring.filter(set => set.id === id)
      if (filtered.length > 0) {
        return filtered[0]
      } else {
        return false
      }
    },
    getScoreBandById (bands, id) {
      const filtered = bands.filter(band => band.id === id)
      if (filtered.length > 0) {
        return filtered[0]
      } else {
        return false
      }
    },
    exists (variable) {
      return typeof variable !== 'undefined'
    },
    cssClass (baseClass, config) {
      let classes = baseClass
      if (typeof config.cssClass !== 'undefined') {
        classes += ' ' + config.cssClass
      }
      return classes
    },
    cssId (config) {
      let id = ''
      if (typeof config.cssId !== 'undefined') {
        id = config.cssId
      }
      return id
    },
    hasSession () {
      return typeof this.$store.state.session.respondentId !== 'undefined'
    },
    getNext (nextOb) {
      if (typeof nextOb === 'number') {
        return nextOb
      }
      if (typeof nextOb === 'string') {
        return this.indexForPageId(nextOb)
      }
      if (Array.isArray(nextOb)) {
        return this.getNextMatch(nextOb)
      }
    },
    getNextMatch (nextOb) {
      const answers = this.$store.state.answers
      for (let i = 0; i < nextOb.length; i++) {
        const clause = nextOb[i]
        let matches = true
        // eslint-disable-next-line no-unused-vars
        for (const prop in clause.if) {
          const match = clause.if[prop]
          if (clause.account) {
            matches = prop === clause.if[prop]
          } else {
            if (answers[prop] !== match) {
              matches = false
            }
          }
        }
        if (matches === true) {
          return this.getNext(clause.then)
        }
      }
      return parseInt(this.$store.state.index) + 1
    },
    indexForQuestionKey (key) {
      const config = this.$store.state.config
      for (let i = 0; i < config.pages.length; i++) {
        const page = config.pages[i]
        if (page.type === 'SurveyPage' && page.options.key === key) {
          return i
        }
      }
      return false
    },
    indexForPageId (id) {
      const config = this.$store.state.config
      for (let i = 0; i < config.pages.length; i++) {
        const page = config.pages[i]
        if (page.id === id) {
          return i
        }
      }
      return false
    },
    questionForKey (key) {
      const config = this.$store.state.config
      const index = this.indexForQuestionKey(key)
      return config.pages[index]
    },
    answerForKey (key) {
      return this.$store.state.answers[key]
    }
  }
}
